import type { PersonalDashboardFacts, PersonalOperatorFacts, PersonalTeamMode } from './reportsPersonalTypes';

export type PersonalSignalContext = {
  teamMode: PersonalTeamMode;
  activeOperatorCount: number;
  branchTicketAverage: number;
  branchCustomLinePct: number;
};

export function resolvePersonalTeamMode(operatorCount: number): PersonalTeamMode {
  if (operatorCount <= 1) return 'solo';
  if (operatorCount === 2) return 'pair';
  return 'team';
}

export function buildPersonalSignalContext(facts: PersonalDashboardFacts): PersonalSignalContext {
  const withSales = facts.operators.filter((o) => o.salesCount > 0);
  const activeOperatorCount = withSales.filter((o) => o.cashierUserId != null).length;
  return {
    teamMode: resolvePersonalTeamMode(activeOperatorCount),
    activeOperatorCount,
    branchTicketAverage: facts.branch.ticketAverage,
    branchCustomLinePct: facts.branch.customLinePct,
  };
}

export function getBranchBenchmarkTicket(operators: PersonalOperatorFacts[]): number {
  const tickets = operators.filter((o) => o.salesCount > 0).map((o) => o.ticketAverage);
  if (tickets.length === 0) return 0;
  return tickets.reduce((a, b) => a + b, 0) / tickets.length;
}
